import React from "react";

import { BlockLogin } from "../components/BlockLogin";

const Login = () => {
  return (
    <BlockLogin />
  );
};

export default Login;